// Componente de logo dinâmico — usa branding do tenant (sem fallback)
import { tenantBranding, tenantLoaded } from '../stores/tenant.store';

export function TenantLogo({ size = 28, ...props }: { size?: number; [key: string]: any }) {
  if (!tenantLoaded.value) return null; // não renderiza até carregar
  // Preferir logo_dark (tema escuro é o padrão)
  const logo = tenantBranding.value?.logo_dark_url || tenantBranding.value?.logo_url;
  const name = tenantBranding.value?.name || '';
  if (!logo) return null;
  return (
    <img
      src={logo}
      alt={name}
      width={size}
      height={size}
      style={{ borderRadius: size > 28 ? 8 : 6 }}
      {...props}
    />
  );
}

/** Retorna o nome do tenant — string vazia enquanto não carregou (sem fallback, sem piscar) */
export function tenantName(): string {
  if (!tenantLoaded.value) return '';
  return tenantBranding.value?.name || '';
}
